module.exports = __webpack_public_path__ + "static/media/personalisedFilter.08c8ad1a.png";